import { REGISTER_REWARD_GUEST_SNOOZE_DATE_KEY } from '@/constants/register-reward';

function formatLocalDateKey(ms = Date.now()) {
  const d = new Date(ms);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** 是否已勾选「今日不再提示」（本地日 0 点切换后失效） */
export function isRegisterRewardGuestSnoozedForToday(nowMs = Date.now()) {
  if (typeof localStorage === 'undefined') return false;
  const saved = String(localStorage.getItem(REGISTER_REWARD_GUEST_SNOOZE_DATE_KEY) ?? '').trim();
  if (!saved) return false;
  const today = formatLocalDateKey(nowMs);
  if (saved === today) return true;
  localStorage.removeItem(REGISTER_REWARD_GUEST_SNOOZE_DATE_KEY);
  return false;
}

/** 写入今日不再提示，次日 0 点自动失效 */
export function snoozeRegisterRewardGuestForToday(nowMs = Date.now()) {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(REGISTER_REWARD_GUEST_SNOOZE_DATE_KEY, formatLocalDateKey(nowMs));
}

/** 登出：清游客「今日不再」 */
export function clearRegisterRewardGuestSnooze() {
  if (typeof localStorage === 'undefined') return;
  try {
    localStorage.removeItem(REGISTER_REWARD_GUEST_SNOOZE_DATE_KEY);
  } catch {
    /* ignore */
  }
}
